import { render, staticRenderFns } from "./QAIndex.vue?vue&type=template&id=6c3c03a6"
import script from "./QAIndex.vue?vue&type=script&lang=js"
export * from "./QAIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports